<div class="bg-img">
  <app-header class="sticky top-header auto-fma" [pageName]="'login'"></app-header>
  <div class="bot">
    <h3 class="title">ASK CIAP</h3>
    >
    <iframe title="Web Chat Bot"
      src="https://webchat.botframework.com/embed/botappIAAI?s=Y0Pi8sOPA00.cwA.2AQ.1nG3yFzzeGl7LYxrHicdMfaLSxnm8Qis-4lxTWZ2GjU "
      (load)="externalContentLoaded()"
    >
    </iframe>
  </div>
</div>
